import { submitInteraction } from 'purchase-motions-api/mutation/ums';
import { UPGRADE_POINT_LOCATIONS } from '../constants/locations';
import { UPGRADE_BANNER_TYPES } from '../constants/ums';
export const trackPotentialBannerInteraction = ({
  pointType,
  upgradeKey
}) => {
  if (pointType && upgradeKey && pointType in UPGRADE_BANNER_TYPES) {
    return submitInteraction({
      upgradeKey
    });
  }
  return Promise.resolve();
};
export const isUpgradePoint = location => UPGRADE_POINT_LOCATIONS.includes(location);